import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, typography, variables }: Theme) => ({
    jetSpinnerRoot:{
        position: 'relative'
    },
    jetSpinnerBottom: {
        color: palette.jet?.contentBrand,
        opacity: '0'
    },
    jetSpinnerTop: {
        color: palette.jet?.contentInteractiveLight,
        animationDuration: '800ms',
        position: 'absolute',
        left:0
    },
    jetSpinnerCircle: {
        strokeLinecap: 'round'
    },

}))


export default styles